import {
    apiRequest,
    riwayatPendidikanDetail,
    riwayatPendidikanApprove
} from "../../../../../services/adapters/kepegawaian/riwayatPendidikanService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatPendidikanDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", riwayatPendidikanApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository